import { error } from '../../../app/logger.js';
import { EventedBase } from '../base/evented_base.js';

/**
 * Event target GoogleMaps class.
 */
class EventedGoogleMaps extends EventedBase {
  on(eventName, listener) {
    switch (eventName) {
      case 'click':
      case 'dblclick':
        return this.native.addListener(eventName, ev => {
          listener({
            lat: ev.latLng.lat(),
            lng: ev.latLng.lng(),
            google_id: ev.placeId,
            stop: () => ev.stop(),
          });
        });

      case 'drag':
      case 'dragend':
        return this.native.addListener(eventName, ev => {
          listener({
            lat: ev.latLng.lat(),
            lng: ev.latLng.lng(),
          });
        });

      default:
        return this.native.addListener(eventName, listener);
    }
  }

  off(unused, listener) {
    listener.remove();
  }

  // Protected

  createNative() {
    error(`[map] createNative must be overriden`);
    return null;
  }

  get native() {
    if (!this.#native) {
      this.#native = this.createNative();
    }
    return this.#native;
  }

  #native;
}

export { EventedGoogleMaps };
